import React, { useEffect, useRef, useState } from 'react';

import Address from '../models/Address';
import AddressAutocomplete from './AddressAutocomplete';
import Grid from '@mui/material/Unstable_Grid2';
import Profile from '../models/Profile';
import ProfileFieldInputVm from '../models/ProfileFieldInputVm';
import UserProfileFieldControls from './UserProfileFieldControls';
import _ from 'lodash';

interface AddressFormProps {
  hideSubFields: boolean;
  indicateErrorOnLoad: boolean;
  profile: Profile;
  values: ProfileFieldInputVm[];
  allRequiredFilledIn: boolean;
  onChange: (input: ProfileFieldInputVm) => void;
}

const AddressForm = (props: AddressFormProps) => {
  const [values, setValues] = useState<ProfileFieldInputVm[]>(props.values);
  const [formatted, setFormatted] = useState('');

  useEffect(() => {
    setValues(props.values);
    const fieldsWithValue = props.values?.filter((v) => !!v.value?.trim());
    console.debug(JSON.stringify(fieldsWithValue));
    if (!_.isEmpty(fieldsWithValue)) {
      setFormatted(fieldsWithValue.map((v) => v.value).join(', '));
    } else {
      setFormatted('');
    }
  }, [JSON.stringify(props.values)]);

  const handleAddressChange = (address: Address) => {
    function getValue(index: number, address: Address) {
      if (!address) {
        return '';
      }

      switch (
        index // * It assumes that the order of the fields is the following.
      ) {
        case 0:
          return address.street;
        case 1:
          return address.suburb;
        case 2:
          return address.city;
        case 3:
          return address.region;
        case 4:
          return address.postcode;
        case 5:
          return address.country;
        default:
          return '';
      }
    }
    props.profile.fields.forEach((f, index) =>
      props.onChange({
        profilekey: f.profilekey,
        fieldposition: f.fieldposition,
        value: getValue(index, address),
        required: f.required
      } as ProfileFieldInputVm)
    );
  };

  function allRequiredFilledIn() {
    if (!props.profile.required) {
      return true;
    }
    if (_.isEmpty(values)) {
      return !props.indicateErrorOnLoad;
    }

    return values?.filter((v) => v.required).every((f) => !!f.value?.trim());
  }

  return (
    <Grid container direction="column">
      <Grid>
        <AddressAutocomplete
          value={formatted}
          hideSubFields={props.hideSubFields}
          required={props.profile.required}
          error={!allRequiredFilledIn()}
          onChange={handleAddressChange}
        />
      </Grid>
      <Grid>
        <UserProfileFieldControls
          indicateErrorOnLoad={props.indicateErrorOnLoad}
          profile={props.profile}
          values={values}
          hidden={props.hideSubFields}
          onChange={props.onChange}
        />
      </Grid>
    </Grid>
  );
};

export default AddressForm;
